/**
 * Copyright (c) 2013 ESHA Research
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * Allows use of the 'overwrite' param on set calls to give an enforced expiration date
 * without breaking existing 'overwrite' functionality.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import type { Moment } from "moment";

declare module "store2" {
	export function useState<S>(
		key: string,
		initialState: (() => S) | S,
		expiry?: Moment,
	): [S, React.Dispatch<React.SetStateAction<S>>];

	export interface StoreAPI {
		useState<S>(
			key: string,
			initialState: (() => S) | S,
			expiry?: Moment,
		): [S, React.Dispatch<React.SetStateAction<S>>];
	}
}

export default function (store: any) {
	const _ = store._;

	store.useState = _.storeAPI.useState = function useState<S>(
		key: string,
		initialState: (() => S) | S,
		expiry?: Moment,
	): [S, React.Dispatch<React.SetStateAction<S>>] {
		const [value, setValue] = React.useState<S>(() => {
			return this.has(key) ? this.get(key) : initialState;
		});

		const isMountRef = React.useRef(true);

		React.useEffect(() => {
			if (isMountRef.current) {
				isMountRef.current = false;
			} else {
				expiry ? this.setExpire(key, value, expiry) : this.set(key, value);
			}
		}, [key, expiry, value]);

		return [value, setValue];
	};

	return store;
}
